import React, { useEffect, useState } from "react";
import { TableCell, Typography } from "@mui/material";
import { Table, Th } from "./../../AvaliaçãoSection/styles";
import {
  Container,
  ContainerInterno,
  ContainerValue,
  Section,
  Title,
  Values,
} from "./styles";
import {
  TipoFormularioRural,
  getTipoFormularioRural,
} from "../../../../Services/alteraImovelForm";
import { tipoFormularioRualList } from "../../../../Utils/tipoFormularioRualList";
import theme from "../../../../Styles/theme";

interface Props {
  id: number;
  total: number;
  transmitida: number;
  APTIDAO_BOA: number;
  APTIDAO_REGULAR: number;
  APTIDAO_RESTRITA: number;
  PASTAGEM_PLANA: number;
  SIVICULTURA: number;
  RESERVA_NATURAL: number;
  TIPO_TERRA_7: number;
  TIPO_TERRA_8: number;
}

export function DimensoesSectionRural({
  id,
  total,
  transmitida,
  APTIDAO_BOA,
  APTIDAO_REGULAR,
  APTIDAO_RESTRITA,
  PASTAGEM_PLANA,
  SIVICULTURA,
  RESERVA_NATURAL,
  TIPO_TERRA_7,
  TIPO_TERRA_8,
}: Props) {
  const [tipoFormularioRural, setTipoFormularioRural] = useState(
    {} as TipoFormularioRural
  );
  const [TIPO_TERRA_CAMPOS, setTIPO_TERRA_CAMPOS] = useState(
    tipoFormularioRualList[0]
  );

  async function handleGetTipoForm() {
    const tipo = await getTipoFormularioRural(id);
    setTIPO_TERRA_CAMPOS(tipoFormularioRualList[1]);
    if (tipo != null) {
      setTipoFormularioRural(tipo);
      setTIPO_TERRA_CAMPOS(tipoFormularioRualList[tipo.TIPO]);
    }
  }

  useEffect(() => {
    handleGetTipoForm();
  }, [
    id,
    total,
    transmitida,
    APTIDAO_BOA,
    APTIDAO_REGULAR,
    APTIDAO_RESTRITA,
    PASTAGEM_PLANA,
    SIVICULTURA,
    RESERVA_NATURAL,
    TIPO_TERRA_7,
    TIPO_TERRA_8,
  ]);

  return (
    <Container style={{}}>
      <Table
        style={{
          width: "100%",
          marginTop: "0px",
          background: theme.colors.light,
          border: "1px solid rgba(224, 224, 224, 1)",
        }}
      >
        <tr>
          <Th style={{ textAlign: "center" }}>Área Total</Th>
          <Th style={{ textAlign: "center" }}>Área Transmitida</Th>
          <Th style={{ textAlign: "center" }}>{TIPO_TERRA_CAMPOS[0].descricao}</Th>
          <Th style={{ textAlign: "center" }}>{TIPO_TERRA_CAMPOS[1].descricao}</Th>
        </tr>
        <tr>
          <TableCell
            style={{
              textAlign: "center",
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color: "black"
            }}
          >
            <Typography variant="body1">
              {total
                ? total.toLocaleString("pt-BR", { minimumFractionDigits: 6 })
                : ""}{" "}
              m²
            </Typography>
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color: "black"
            }}
          >
            <Typography variant="body1">
              {transmitida
                ? transmitida.toLocaleString("pt-BR", {
                  minimumFractionDigits: 6,
                })
                : "0"}{" "}
              m²
            </Typography>
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color: "black"
            }}
          >
            <Typography variant="body1">
              {APTIDAO_BOA ? APTIDAO_BOA.toLocaleString("pt-br") : 0}%
            </Typography>
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color: "black"
            }}
          >
            <Typography variant="body1">
              {APTIDAO_REGULAR ? APTIDAO_REGULAR.toLocaleString("pt-br") : 0}%
            </Typography>
          </TableCell>
        </tr>
      </Table>

      <Table
        style={{
          width: "100%",
          marginTop: "0px",
          background: theme.colors.light,
          border: "1px solid rgba(224, 224, 224, 1)",
        }}
      >
        <tbody>
          <tr>
            {TIPO_TERRA_CAMPOS.slice(2, 8).map((item: any, index: number) => {
              return (
                <Th key={index} style={{ textAlign: "center" }}>
                  {item.descricao || "-"}
                </Th>
              );
            })}
          </tr>
        </tbody>
        

        <tr>
          <TableCell
            style={{
              textAlign: "center",
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color: "black"
            }}
          >
            <Typography variant="body1">
              {APTIDAO_RESTRITA ? APTIDAO_RESTRITA.toLocaleString("pt-br") : 0}%
            </Typography>
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color: "black"
            }}
          >
            <Typography variant="body1">
              {PASTAGEM_PLANA ? PASTAGEM_PLANA.toLocaleString("pt-br") : 0}%
            </Typography>
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color: "black"
            }}
          >
            <Typography variant="body1">
              {SIVICULTURA ? SIVICULTURA.toLocaleString("pt-br") : 0}%
            </Typography>
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color: "black"
            }}
          >
            <Typography variant="body1">
              {RESERVA_NATURAL ? RESERVA_NATURAL.toLocaleString("pt-br") : 0}%
            </Typography>
          </TableCell>
          {tipoFormularioRural.TIPO > 1 && (
            <>
              <TableCell
                style={{
                  textAlign: "center",
                  border: "1px solid rgba(224, 224, 224, 1)",
                  padding: "0px",
                  color: "black"
                }}
              >
                <Typography variant="body1">
                  {TIPO_TERRA_7 ? TIPO_TERRA_7.toLocaleString("pt-br") : 0}%
                </Typography>
              </TableCell>
              <TableCell
                style={{
                  textAlign: "center",
                  border: "1px solid rgba(224, 224, 224, 1)",
                  padding: "0px",
                  color: "black"
                }}
              >
                <Typography variant="body1">
                  {TIPO_TERRA_8 ? TIPO_TERRA_8.toLocaleString("pt-br") : 0}%
                </Typography>
              </TableCell>
            </>
          )}
        </tr>
      </Table>
    </Container>
  );
}
